import React from "react";
import styles from "./no-data-in-timeframe.module.scss";
import { useI18N } from "@src/language/language-context";

const cssClassName = "no-data-in-timeframe";

/** Shown inside OPCUA widgets when the queried values array is empty. */
export const NoDataInTimeframe = () => {
  const i18n = useI18N();
  const text = i18n("modules.noDataInTimeframe.noDataInTimeframe");

  return <div className={styles[cssClassName]}>{text}</div>;
};
